import useSiteConfiguration from '@frontend/libs/hooks/useSiteConfiguration'
import facebookIcon from '@images/icons/facebook.svg'
import instagramIcon from '@images/icons/instagram.svg'
import lineIcon from '@images/icons/line.svg'
import spotifyIcon from '@images/icons/spotify.svg'
import { Image } from '@nextui-org/react'

import IframeComponent from '../iframe-component/IframeComponent'

export function ContactSection() {
  const { settings } = useSiteConfiguration()
  return (
    <div className="grid gap-10 md:grid-cols-2">
      <div className="uppercase">
        <h3 className="mb-4 font-semibold">HEADQUARTER</h3>
        <p className="mb-4">{settings?.contactInfo.address}</p>
        {settings?.contactInfo.phoneNumber && (
          <p>
            TEL.{' '}
            <a href={`tel:${settings?.contactInfo.phoneNumber}`}>
              {settings?.contactInfo.phoneNumber}
            </a>
          </p>
        )}
        {settings?.contactInfo.email && (
          <p>
            <a href={`mailto:${settings?.contactInfo.email}`}>
              {settings?.contactInfo.email}
            </a>{' '}
            | WWW.ASAVAGROUP.COM
          </p>
        )}
        <div className="mt-4 flex gap-4">
          {settings?.socialMedia.facebook && (
            <a
              className="block"
              href={settings.socialMedia.facebook}
              rel="noreferrer"
              target="_blank"
            >
              <Image alt="Facebook" className="h-8 w-8" src={facebookIcon} />
            </a>
          )}
          {settings?.socialMedia.instagram && (
            <a
              className="block"
              href={settings.socialMedia.instagram}
              rel="noreferrer"
              target="_blank"
            >
              <Image alt="Instagram" className="h-8 w-8" src={instagramIcon} />
            </a>
          )}
          {settings?.socialMedia.line && (
            <a
              className="block"
              href={settings.socialMedia.line}
              rel="noreferrer"
              target="_blank"
            >
              <Image alt="Line" className="h-8 w-8" src={lineIcon} />
            </a>
          )}
          {settings?.socialMedia.spotify && (
            <a
              className="block"
              href={settings.socialMedia.spotify}
              rel="noreferrer"
              target="_blank"
            >
              <Image alt="Spotify" className="h-8 w-8" src={spotifyIcon} />
            </a>
          )}
        </div>
      </div>
      <div>
        <IframeComponent
          slug={`contact-form`}
          sourceUrl="/component/contact-form/"
        />
      </div>
    </div>
  )
}

export default ContactSection
